import { ITALIAN } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Italian
const ITSection: Section[] = [
  {
    name: '1: Riferimenti e panoramica',
    subSections: [
      {
        name: 'Premessa',
        page: 3,
      },
      {
        name: 'Finalità e applicazioni sul campo',
        page: 4,
      },
      {
        name: 'Definizioni chiave',
        page: 5,
      },
      {
        name: 'Gerarchia dei controlli',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFEsaver',
    subSections: [
      {
        name: 'Sicurezza stradale per veicoli a motore',
        page: 9,
      },
      {
        name: 'Lavoro in quota',
        page: 12,
      },
      {
        name: 'Macchine semoventi',
        page: 18,
      },
      {
        name: 'Messa in sicurezza – Isolamento delle fonti di alimentazione',
        page: 22,
      },
      {
        name: 'Lavori in presenza di corrente elettrica',
        page: 25,
      },
      {
        name: 'Spazio confinato',
        page: 29,
      },
      {
        name: 'Stoccaggio di materiali sfusi',
        page: 32,
      },
      {
        name: 'Sicurezza dei vagoni ferroviari',
        page: 37,
      },
      {
        name: 'Lavori di scavo',
        page: 41,
      },
      {
        name: 'Imbracatura e sollevamento',
        page: 45,
      },
      {
        name: 'Materiali pericolosi',
        page: 47,
      },
      {
        name: 'Lavori a caldo',
        page: 52,
      },
    ],
  },
  {
    name: '3: Risorse e strumenti aggiuntivi',
    subSections: [
      {
        name: `Lavorare in prossimità e vicino all'acqua`,
        page: 58,
      },
      {
        name: 'Oggetti caduti o a rischio caduta',
        page: 59,
      },
      {
        name: 'Test atmosferico/dei gas',
        page: 59,
      },
      {
        name: 'Comunicazione di rischi legati a sostanze chimiche',
        page: 65,
      },
    ],
  },
  {
    name: '4: Pratiche Cargill per la gestione della sicurezza',
    subSections: [
      {
        name: 'Terminologia principale',
        page: 70,
      },
      {
        name: 'Individuazione di incidenti e infortuni gravi (Serious Injury and Fatality - SIF) per evento',
        page: 72,
      },
      {
        name: 'Suddivisione in categorie del potenziale di incidenti e infortuni gravi (Serious Injury and Fatality Potential SIFp)',
        page: 73,
      },
      {
        name: 'Tabella dei criteri di determinazione automatica SIF',
        page: 74,
      },
      {
        name: 'Prestazioni umane e organizzative (Human & Organizational Performance - HOP)',
        page: 76,
      },
    ],
  },
];
const ITTableofContent: TableOfContent = {
  language: 'it',
  sections: ITSection,
  label: 'Sommario',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide ITALIAN_(it_IT)_CROPPED.pdf',
  hopPocket: 'Guida tascabile HOP',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Italian.pdf',
  source: ITALIAN,
};

export default ITTableofContent;
